var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 pt-1 m-auto",attrs:{"id":"content"}},[_c('router-view',[_c('div',{attrs:{"id":"load_screen"}},[_c('div',{staticClass:"loader"},[_c('div',{staticClass:"loader-content"},[_c('div',{staticClass:"spinner-grow align-self-center"})])])])])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }